module.exports = __webpack_public_path__ + "img/dianzi.87712aeb.png";